import React, { useEffect, useState } from 'react'
import {
  Grid,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
  CircularProgress,
  Box,
} from '@material-ui/core'
import './crearFormulario.scss'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useForm } from '../../../../context/formContext'
import { useAuthentication } from '../../../../context/authenticationContext'
import NumberFormat from 'react-number-format'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import { getCurrencyExchange } from '../../../../services/Forms/get'
import SelectReact from 'react-select'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import Modal from '@mui/material/Modal'
import ModalRegister from '../../RegistroMipymes/ModalRegister'

const GeneralData = (props) => {
  const { nextStep } = props
  const {
    setStep,
    step,
    setPreEligibilityForm,
    preEligibilityForm,
    miPymesType,
    currencies,
    pymeList,
    setCheckPYME,
    getMiPymeList,
  } = useForm()
  const {
    // userName,
    userFullName,
    userCompanyID,
    userCompanyType,
    userCountry,
    userCompanyName,
  } = useAuthentication()
  const [showRequiredAmount, setShowRequiredAmount] = useState(false)
  const [showExchange, setShowExchange] = useState(false)
  const [loadingExchange, setLoadingExchange] = useState(false)
  const [amountExchange, setAmountExchange] = useState('$0.00')
  const [exchangeError, setExchangeError] = useState(false)
  const [amountTest, setAmountTest] = useState('')
  const [options, setOptions] = useState([])
  const [enablePYME, setEnablePYME] = useState(true)
  const [selectedPYME, setSelectedPYME] = useState('')
  const [pymeError, setPymeError] = useState('')

  const [open, setOpen] = React.useState(false)
  const [openRegister, setOpenRegister] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    setOpen(false)
    setSelectedPYME('')
  }

  const handleCloseRegister = () => {
    setOpenRegister(false)
    getMiPymeList()
  }

  const handleOpenRegister = () => {
    setOpenRegister(true)
    setOpen(false)
  }

  // const handleCloseRegister = () => setOpenRegister(false)

  const GeneralDataSchema = Yup.object().shape({
    userFullName: Yup.string().required('Este campo es obligatorio'),
    companyName: Yup.string().required('Este campo es obligatorio'),
    companyTypeId: Yup.number().required('Este campo es obligatorio'),
    companyId: Yup.string().required('Este campo es obligatorio'),
    legalRepresentativeFullName: Yup.string().required(
      'Este campo es obligatorio',
    ),
    legalRepresentativeIdentification: Yup.string().required(
      'Este campo es obligatorio',
    ),
    subprojectName: Yup.string().required('Este campo es obligatorio'),
    quantityEmployees: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio')
      .test(
        'superior',
        'El número de empleados debe ser mayor que 0',
        function (f) {
          const ref = 0
          return f > this.resolve(ref)
        },
      ),
    idCurrency: Yup.number().required('Este campo es obligatorio'),
    requiredAmountSourceCurrency: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio')
      .test(
        'superior',
        'El monto requerido debe ser mayor que 0',
        function (f) {
          const ref = 0
          return f > this.resolve(ref)
        },
      ),
    // requiredAmountSourceCurrency: Yup.number()
    //   .required('Este campo es obligatorio')
    //   .typeError('Este campo es obligatorio')
    //   .test(
    //     'superior',
    //     'El monto requerido debe ser mayor que 0',
    //     function (f) {
    //       const ref = 0
    //       return f > this.resolve(ref)
    //     },
    //   ),
  })

  const formik = useFormik({
    initialValues: {
      userFullName: userFullName,
      companyName: '',
      companyTypeId: '',
      companyId: '',
      legalRepresentativeFullName: '',
      legalRepresentativeIdentification: '',
      subprojectName: '',
      quantityEmployees: null,
      idCurrency: '',
      requiredAmountSourceCurrency: null,
      requiredAmountDollarsCurrency: '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      next()
    },
  })

  // useEffect(() => {
  //   // datos obligatiros
  //   if (
  //     selectedPYME !== '' &&
  //     formik.values.companyId !== '' &&
  //     formik.values.legalRepresentativeFullName !== '' &&
  //     formik.values.legalRepresentativeIdentification !== '' &&
  //     formik.values.subprojectName !== '' &&
  //     formik.values.quantityEmployees !== null &&
  //     formik.values.quantityEmployees !== '' &&
  //     formik.values.idCurrency !== '' &&
  //     formik.values.requiredAmountDollarsCurrency !== ''
  //   ) {
  //     setCheckPYME(true)
  //   } else {
  //     setCheckPYME(false)
  //   }
  // }, [
  //   selectedPYME,
  //   formik.values.companyId,
  //   formik.values.legalRepresentativeFullName,
  //   formik.values.legalRepresentativeIdentification,
  //   formik.values.subprojectName,
  //   formik.values.quantityEmployees,
  //   formik.values.quantityEmployees,
  //   formik.values.idCurrency,
  //   formik.values.requiredAmountDollarsCurrency,
  // ])

  useEffect(() => {
    // datos obligatorios
    if (
      selectedPYME.value !== 0 &&
      formik.values.companyId !== '' &&
      formik.values.legalRepresentativeFullName !== '' &&
      formik.values.legalRepresentativeIdentification !== '' &&
      formik.values.subprojectName !== '' &&
      formik.values.quantityEmployees !== null &&
      formik.values.quantityEmployees !== '' &&
      formik.values.idCurrency !== '' &&
      (formik.values.requiredAmountSourceCurrency !== null ||
        formik.values.requiredAmountDollarsCurrency !== '')
    ) {
      setCheckPYME(true)
    } else {
      setCheckPYME(false)
    }
  }, [
    selectedPYME,
    formik.values.companyId,
    formik.values.legalRepresentativeFullName,
    formik.values.legalRepresentativeIdentification,
    formik.values.subprojectName,
    formik.values.quantityEmployees,
    formik.values.quantityEmployees,
    formik.values.idCurrency,
    formik.values.requiredAmountDollarsCurrency,
    formik.values.requiredAmountSourceCurrency,
  ])

  useEffect(() => {
    if (
      formik.values.idCurrency !== '' &&
      formik.values.idCurrency !== undefined &&
      formik.values.idCurrency === 3
    ) {
      setShowRequiredAmount(true)
      setLoadingExchange(false)
      setAmountExchange('$0.00')
    } else if (
      formik.values.idCurrency !== '' &&
      formik.values.idCurrency !== undefined &&
      formik.values.idCurrency !== 3
    ) {
      setShowRequiredAmount(true)
      setShowExchange(true)
      if (formik.values.requiredAmountSourceCurrency !== '') {
        getExchange()
      }
    } else {
      setShowRequiredAmount(false)
      setPreEligibilityForm({
        ...preEligibilityForm,
        requiredAmountSourceCurrency: '',
      })
    }
  }, [formik.values.idCurrency])

  const next = () => {
    setStep(step + 1)
    setPreEligibilityForm({
      ...preEligibilityForm,
      userFullName: formik.values.userFullName,
      companyName: formik.values.companyName,
      companyTypeId: formik.values.companyTypeId,
      companyId: formik.values.companyId,
      legalRepresentativeFullName: formik.values.legalRepresentativeFullName,
      legalRepresentativeIdentification:
        formik.values.legalRepresentativeIdentification,
      subprojectName: formik.values.subprojectName,
      quantityEmployees: formik.values.quantityEmployees,
      idCurrency: formik.values.idCurrency,
      requiredAmountSourceCurrency: formik.values.requiredAmountSourceCurrency,
      requiredAmountDollarsCurrency:
        formik.values.requiredAmountDollarsCurrency,
    })
    nextStep()
  }

  useEffect(() => {
    if (formik.values.idCurrency === '') {
      setAmountTest('')
      setShowRequiredAmount(false)
      setShowExchange(false)
      setAmountExchange('$0.00')
      formik.setFieldValue('requiredAmountDollarsCurrency', '')
      formik.setFieldValue('requiredAmountSourceCurrency', '')
      setPreEligibilityForm({
        ...preEligibilityForm,
        requiredAmountSourceCurrency: 0,
        requiredAmountDollarsCurrency: 0,
      })
    }

    if (formik.values.idCurrency !== '' && formik.values.idCurrency !== 3) {
      setAmountTest('')
      setLoadingExchange(false)
      formik.setFieldValue('requiredAmountDollarsCurrency', '')
      formik.setFieldValue('requiredAmountSourceCurrency', '')
      setPreEligibilityForm({
        ...preEligibilityForm,
        requiredAmountSourceCurrency: 0,
        requiredAmountDollarsCurrency: 0,
      })
    }

    if (formik.values.idCurrency !== '' && formik.values.idCurrency === 3) {
      setAmountTest('')
      formik.setFieldValue('requiredAmountDollarsCurrency', '')
      formik.setFieldValue('requiredAmountSourceCurrency', '')
      setPreEligibilityForm({
        ...preEligibilityForm,
        requiredAmountSourceCurrency: 0,
        requiredAmountDollarsCurrency: 0,
      })
    }
  }, [formik.values.idCurrency])

  const getExchange = () => {
    let currencyCode = ''

    setExchangeError(false)

    if (
      formik.values.requiredAmountSourceCurrency !== '' &&
      formik.values.idCurrency !== '' &&
      formik.values.idCurrency !== undefined
    ) {
      for (let i = 0; i <= currencies.length; i++) {
        if (currencies[i].IdCurrency === formik.values.idCurrency) {
          currencyCode = currencies[i].CurrencyCode
          break
        }
      }
    }

    if (
      formik.values.idCurrency !== 3 &&
      formik.values.idCurrency !== '' &&
      formik.values.idCurrency !== undefined
    ) {
      if (formik.values.requiredAmountSourceCurrency !== '') {
        setLoadingExchange(true)

        const amountCurrencyCode = currencyCode
        const params = {
          SourceCurrencyCode: amountCurrencyCode,
          TargetCurrencyCode: 'USD',
          OriginalAmount: formik.values.requiredAmountSourceCurrency,
        }
        getCurrencyExchange(params)
          .then((res) => {
            if (
              res.error !== null ||
              res?.result
                ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                ?.currencyExchange?.resultingAmount === 0
            ) {
              setLoadingExchange(false)
              setAmountExchange('$0.00')
              setExchangeError(true)

              if (
                res?.result
                  ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                  ?.currencyExchange?.resultingAmount === 0
              ) {
                setLoadingExchange(false)
                setAmountExchange('$0.00')
                setExchangeError(true)
              }
            } else {
              if (
                res?.result
                  ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                  ?.currencyExchange?.resultingAmount
              ) {
                setLoadingExchange(false)
                setAmountExchange(
                  `$${res?.result?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse?.currencyExchange?.resultingAmount}`,
                )
                formik.setFieldValue(
                  'requiredAmountDollarsCurrency',
                  res?.result
                    ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                    ?.currencyExchange?.resultingAmount,
                )

                setPreEligibilityForm({
                  ...preEligibilityForm,
                  requiredAmountDollarsCurrency:
                    res?.result
                      ?.retrieveGlobalStandardSpecificationCurrencyExchangeResponse
                      ?.currencyExchange?.resultingAmount,
                })

                setExchangeError(false)
              } else {
                setLoadingExchange(false)
                formik.setFieldValue('requiredAmountDollarsCurrency', 0)
                setPreEligibilityForm({
                  ...preEligibilityForm,
                  requiredAmountDollarsCurrency: 0,
                })
              }
            }
          })
          .catch((err) => {
            console.log(err)
            setExchangeError(true)
            setLoadingExchange(false)
            setAmountExchange('$0.00')
          })
      } else {
        setLoadingExchange(false)
        setAmountExchange('$0.00')
      }
    } else {
      setLoadingExchange(false)
      setAmountExchange('$0.00')
    }
  }

  const getPatternMiPymeId = () => {
    if (parseInt(userCountry) !== null) {
      switch (parseInt(userCountry)) {
        case 1:
          return '[\\0-9]{0,15}'
        case 2:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 3:
          return '[0-9]{0,15}'
        case 4:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 5:
          return '[0-9]{0,15}'
        case 6:
          return '[sa-zA-ZñÑ0-9]{0,17}'
        case 7:
          return '[0-9]{0,15}'
        default:
          return null
      }
    } else {
      return null
    }
  }

  const handlePYME = () => {
    if (selectedPYME && selectedPYME.value !== 0) {
      // setCheckPYME(true)
      setSelectedPYME('')
      setPymeError('')
      const data = pymeList.filter((e) => e.IdMiPyme === selectedPYME.value)
      formik.setValues({
        ...formik.values,
        companyName: data[0].BusinessName,
        companyTypeId: parseInt(data[0].IdMiPymeType),
        companyId: data[0].TaxRegistration,
      })
      setPreEligibilityForm({
        ...preEligibilityForm,
        userFullName: userFullName,
        companyName: data[0].BusinessName,
        companyTypeId: parseInt(data[0].IdMiPymeType),
        companyId: data[0].TaxRegistration.toString(),
      })
      setEnablePYME(false)
      handleClose()
    } else {
      setPymeError('Campo Obligatorio')
      setSelectedPYME('')
    }
  }

  useEffect(() => {
    if (pymeList && pymeList.length > 1) {
      const array = []
      let struct
      for (let i = 0; i < pymeList.length; i++) {
        struct = {
          value: pymeList[i].IdMiPyme,
          label:
            ` ${pymeList[i].TaxRegistration}` +
            ' - ' +
            `${pymeList[i].BusinessName}`,
        }
        array.push(struct)
      }
      if (array.length > 0) {
        setOptions(array)
      } else {
        setOptions([])
      }
    } else {
      setOptions([])
    }

    if (pymeList && pymeList.length === 1) {
      // setCheckPYME(true)
      formik.setValues({
        ...formik.values,
        companyName: userCompanyName,
        companyTypeId: parseInt(userCompanyType),
        companyId: userCompanyID,
      })

      setEnablePYME(false)
    }
  }, [pymeList])

  useEffect(() => {
    if (selectedPYME && selectedPYME.value !== '') {
      setPymeError('')
    }
  }, [selectedPYME])

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="linkToMIPYME">
            <span>¿Nueva MIPYME?</span>
            <a onClick={handleOpenRegister}>Registrar</a>
          </div>
          <div className="pymeDiv">
            <h1 className="pymeTitle">Seleccione una MIPYME</h1>
            <p className="pymeDescription">
              Es necesario seleccionar una MIPYME para registrar un formulario
            </p>
          </div>
          {pymeList && pymeList.length > 1 ? (
            <Grid container spacing={1} className="input__container selectPYME">
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <SelectReact
                    classNamePrefix="select"
                    options={options}
                    placeholder="Escriba el nombre de la MIPYME"
                    onChange={(e) => setSelectedPYME(e)}
                    isClearable={true}
                    isSearchable={true}
                    defaultValue={selectedPYME}
                  />
                </FormControl>
                {pymeError !== '' ? (
                  <div
                    style={{ color: 'red', marginTop: '4px', fontSize: '13px' }}
                  >
                    {pymeError}
                  </div>
                ) : null}
              </Grid>
              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button className="confirmButton" onClick={() => handlePYME()}>
                  Seleccionar
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </Box>
      </Modal>

      <form id="transfers-form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          {/*           {pymeList && pymeList.length > 1 ? (
            <Grid
              container
              spacing={1}
              className="input__container"
              style={{ display: 'none' }}
            >
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Seleccionar MIPYME</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <SelectReact
                    options={options}
                    placeholder="Seleccionar MIPYME"
                    onChange={(e) => setSelectedPYME(e.value)}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : null}
 */}
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">1. Nombre Completo</label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="fullName"
                  style={{ width: '100%' }}
                  error={formik.errors.userFullName}
                  variant="outlined"
                  disabled
                  onChange={(e) => {
                    formik.setFieldValue('userFullName', e.target.value)
                    if (!formik.errors.userFullName) {
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        userFullName: e.target.value,
                      })
                    }
                  }}
                  value={formik.values.userFullName}
                />
                {formik.errors.userFullName ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.userFullName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">2. Nombre de la MIPYME</label>
              <a
                data-tip="- Seleccione la entidad MIPYME deseada para la creación <br/> del formulario (Siempre que haya más de una MIPYME creada)"
                data-for="infoPymesPop"
                style={{ cursor: 'pointer' }}
              >
                <ErrorOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoPymesPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <div className="pymeSelect">
                  <TextField
                    id="companyName"
                    style={{ width: '100%' }}
                    error={formik.errors.companyName}
                    variant="outlined"
                    disabled
                    onChange={(e) => {
                      formik.setFieldValue('companyName', e.target.value)
                      if (!formik.errors.companyName) {
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          companyName: e.target.value,
                        })
                      }
                    }}
                    value={formik.values.companyName}
                  />
                  <a
                    data-tip="Seleccione una MIPYME para continuar con el registro de un formulario"
                    data-for="infoPYMEPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <Button
                      variant="outlined"
                      disabled={pymeList && pymeList.length === 1}
                      className={
                        pymeList && pymeList.length === 1
                          ? 'modalPYMESDisable'
                          : 'modalPYMES'
                      }
                      onClick={handleOpen}
                      data-tip="infoPYMEPop"
                    >
                      <ManageSearchIcon />
                    </Button>

                    <ReactTooltip
                      id="infoPYMEPop"
                      multiline={true}
                      type="dark"
                      disable={pymeList && pymeList.length === 1}
                    />
                  </a>
                </div>

                {formik.errors.companyName ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.companyName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">3.Tipo de la MIPYME</label>{' '}
              {/* <span style={{ color: 'red' }}>*</span> */}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="companyTypeId"
                  error={formik.errors.companyTypeId}
                  variant="outlined"
                  onChange={(e) => {
                    formik.setFieldValue('companyTypeId', e.target.value)

                    setPreEligibilityForm({
                      ...preEligibilityForm,
                      companyTypeId: e.target.value,
                    })
                  }}
                  value={formik.values.companyTypeId}
                  disabled
                >
                  <MenuItem value={''}>Seleccione una opción</MenuItem>
                  {miPymesType &&
                    miPymesType.map((item, key) => (
                      <MenuItem key={key} value={item.IdMiPymeType}>
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.companyTypeId ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.companyTypeId}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                4. Registro tributario o identificación de la MIPYME
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="companyId"
                  style={{ width: '100%' }}
                  error={formik.errors.companyId}
                  variant="outlined"
                  onChange={(e) => {
                    formik.setFieldValue('companyId', e.target.value)
                    if (!formik.errors.companyId) {
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        companyId: e.target.value,
                      })
                    }
                  }}
                  value={formik.values.companyId}
                  disabled
                />
                {formik.errors.companyId ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.companyId}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                5. Nombre del representante legal{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="legalRepresentativeFullName"
                  style={{ width: '100%' }}
                  error={formik.errors.legalRepresentativeFullName}
                  variant="outlined"
                  value={formik.values.legalRepresentativeFullName}
                  inputProps={{
                    maxLength: 100,
                    autoComplete: 'new-text',
                    pattern: '[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,100}',
                  }}
                  onChange={(e) => {
                    if (e.target.validity.valid) {
                      formik.setFieldValue(
                        'legalRepresentativeFullName',
                        e.target.value,
                      )
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        legalRepresentativeFullName: e.target.value,
                      })
                    }
                  }}
                />
                {formik.errors.legalRepresentativeFullName ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.legalRepresentativeFullName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                6. Número de identificación del representante legal{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="legalRepresentativeIdentification"
                  style={{ width: '100%' }}
                  error={formik.errors.legalRepresentativeIdentification}
                  variant="outlined"
                  inputProps={{
                    autoComplete: 'off',
                    pattern: getPatternMiPymeId(),
                  }}
                  onChange={(e) => {
                    if (e.target.validity.valid) {
                      formik.setFieldValue(
                        'legalRepresentativeIdentification',
                        e.target.value,
                      )
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        legalRepresentativeIdentification: e.target.value,
                      })
                    }
                  }}
                  value={formik.values.legalRepresentativeIdentification}
                />
                {formik.errors.legalRepresentativeIdentification ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.legalRepresentativeIdentification}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                7. Nombre del subproyecto{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="subprojectName"
                  style={{ width: '100%' }}
                  error={formik.errors.subprojectName}
                  variant="outlined"
                  inputProps={{
                    autoComplete: 'off',

                    maxLength: 100,
                  }}
                  onChange={(e) => {
                    if (e.target.validity.valid) {
                      formik.setFieldValue('subprojectName', e.target.value)
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        subprojectName: e.target.value,
                      })
                    }
                  }}
                  value={formik.values.subprojectName}
                />
                {formik.errors.subprojectName ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.subprojectName}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                8. Cantidad de empleados permanentes{' '}
                <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Ingrese la cantidad total de empleados permanentes<br/> o directos de la MIPYME; no incluir empleados eventuales."
                  data-for="infoEmployesPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoEmployesPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                {/* <TextField
                  id="quantityEmployees"
                  style={{ width: '100%' }}
                  error={formik.errors.quantityEmployees}
                  variant="outlined"
                  inputProps={{ autoComplete: 'off', pattern: '[0-9]{0,5}' }}
                  onChange={(e) => {
                    if (e.target.validity.valid) {
                      if (e.target.value !== '') {
                        formik.setFieldValue(
                          'quantityEmployees',
                          parseInt(e.target.value),
                        )
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          quantityEmployees: parseInt(e.target.value),
                        })
                      } else {
                        formik.setFieldValue('quantityEmployees', '')
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          quantityEmployees: '',
                        })
                      }
                    }
                  }}
                  value={formik.values.quantityEmployees}
                /> */}
                <NumberFormat
                  id="quantityEmployees"
                  name="quantityEmployees"
                  customInput={TextField}
                  thousandSeparator={true}
                  value={formik.values.quantityEmployees}
                  onChange={(e) => {
                    if (e.target.value.replaceAll(',', '') !== '') {
                      formik.setFieldValue(
                        'quantityEmployees',
                        parseInt(e.target.value.replaceAll(',', '')),
                      )
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        quantityEmployees: parseInt(
                          e.target.value.replaceAll(',', ''),
                        ),
                      })
                    } else {
                      formik.setFieldValue('quantityEmployees', '')
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        quantityEmployees: '',
                      })
                    }
                  }}
                  autoComplete="off"
                  allowNegative={false}
                  error={formik.errors.quantityEmployees}
                  variant="outlined"
                  isNumericString={true}
                  inputProps={{ maxLength: 5 }}
                  fixedDecimalScale
                  decimalScale={0}
                />
                {formik.errors.quantityEmployees ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.quantityEmployees}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                9. Moneda del monto <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="Ingrese la moneda de préstamo"
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="currency"
                  value={formik.values.idCurrency}
                  onChange={(e) => {
                    formik.setFieldValue('idCurrency', e.target.value)
                    setPreEligibilityForm({
                      ...preEligibilityForm,
                      idCurrency: e.target.value,
                    })
                    if (e.target.value !== 3) {
                      setShowExchange(true)
                    } else {
                      setShowExchange(false)
                    }
                  }}
                  variant="outlined"
                  error={formik.errors.idCurrency}
                >
                  <MenuItem value={''}>Seleccione una opción</MenuItem>
                  {currencies &&
                    currencies.map((item, key) => (
                      <MenuItem key={key} value={item.IdCurrency}>
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.idCurrency ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.idCurrency}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          {showRequiredAmount && (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  10. Monto requerido <span style={{ color: 'red' }}>*</span>
                  <a
                    data-tip="
                      a. Microempresa (Hasta 5 empleados): Hasta $100,000.00<br/>
                      b. Pequeña Empresa (De 6 a 50 empleados): Hasta $400,000.00<br/>
                      c. Mediana Empresa (De 51 a 100 empleados): Hasta $1,000,000.00
                    "
                    data-for="infoAmountPop"
                    style={{ cursor: 'pointer', textAlign: 'justify' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoAmountPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                      className="ayudaResponsive"
                    />
                  </a>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="requiredAmountSourceCurrency"
                    name="requiredAmountSourceCurrency"
                    customInput={TextField}
                    thousandSeparator={true}
                    value={amountTest}
                    allowLeadingZeros={false}
                    onChange={(e) => {
                      let inputValue = e.target.value.replaceAll(',', '')

                      // Remove non-numeric characters
                      // Limit the input length to 18 characters

                      if (inputValue.length > 12) {
                        inputValue = inputValue.slice(0, 12)
                      }

                      inputValue = Number(inputValue)

                      setAmountTest(inputValue)
                      if (formik.values.idCurrency === 3) {
                        formik.setFieldValue(
                          'requiredAmountDollarsCurrency',
                          inputValue,
                        )
                        formik.setFieldValue(
                          'requiredAmountSourceCurrency',
                          inputValue,
                        )
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          requiredAmountSourceCurrency: inputValue,
                          requiredAmountDollarsCurrency: inputValue,
                        })
                      } else if (
                        formik.values.idCurrency !== 3 &&
                        formik.values.idCurrency !== ''
                      ) {
                        formik.setFieldValue(
                          'requiredAmountSourceCurrency',
                          inputValue,
                        )
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          requiredAmountSourceCurrency: inputValue,
                        })
                      }
                    }}
                    autoComplete="off"
                    allowNegative={false}
                    error={formik.errors.requiredAmountSourceCurrency}
                    variant="outlined"
                    onBlur={() => getExchange()}
                    isNumericString={true}
                    inputProps={{ maxLength: 18 }}
                    fixedDecimalScale
                    decimalScale={2}
                  />
                  {formik.errors.requiredAmountSourceCurrency ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.requiredAmountSourceCurrency}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          )}
          {showExchange ? (
            <Grid item xs={12} sm={12} md={12} style={{ marginTop: '8px' }}>
              <label style={{ color: '#8080809e', fontWeight: '400' }}>
                Equivalente en dólares:{' '}
                {loadingExchange ? (
                  <CircularProgress color="inherit" size={17} />
                ) : (
                  <strong>
                    <NumberFormat
                      value={amountExchange || 0.0}
                      thousandSeparator={true}
                      decimalScale={2}
                      displayType={'text'}
                      isNumericString={true}
                      fixedDecimalScale
                    />
                  </strong>
                )}
              </label>
            </Grid>
          ) : null}

          <Grid container spacing={1} className="general_button">
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
              {!enablePYME ? (
                <Button
                  type="submit"
                  className="button__wizard button__next"
                  disabled={loadingExchange || exchangeError}
                >
                  Siguiente
                </Button>
              ) : (
                <Button
                  type="submit"
                  className="button__wizard button__next"
                  disabled={true}
                >
                  Siguiente
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
        <ModalRegister
          open={openRegister}
          handleClose={() => handleCloseRegister()}
        />
      </form>
    </>
  )
}

export default GeneralData
